import React from "react";
import About from "../component/About";
function Pass_About() {
  return (
    <>
      <About />
    </>
  );
}

export default Pass_About;
